import { useEffect, useRef, useState } from "react";

import {
  TOUR_LABEL_PADRAO,
  TOUR_TOOLTIP_PADRAO,
  TOUR_MENU_TITULO_PADRAO,
  TOUR_TROCAR_TOPICO,
  TOUR_TOUR_GUIADO,
} from "constants/tourGuiado";

import * as S from "./styles";
import { useGuidedTour } from "./useGuidedTour";

// Botão "Como usar" + menu de ajuda, reutilizável em qualquer tela.
export const HelpButton = ({
  steps = [],
  label = TOUR_LABEL_PADRAO,
  tooltip = TOUR_TOOLTIP_PADRAO,
  menuTitulo = TOUR_MENU_TITULO_PADRAO,
  options,
}) => {
  const { start, show, topics } = useGuidedTour(steps, options);
  const [aberto, setAberto] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!aberto) return undefined;
    const onDoc = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setAberto(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [aberto]);

  return (
    <S.HelpWrap ref={wrapRef}>
      <S.ShepherdTheme />
      <S.HelpBtn type="button" onClick={() => setAberto(o => !o)}>
        <span aria-hidden>?</span>
        {label}
      </S.HelpBtn>
      {!aberto && <S.HelpTooltip>{tooltip}</S.HelpTooltip>}
      {aberto && (
        <S.HelpMenu>
          <S.HelpMenuTitulo>{menuTitulo}</S.HelpMenuTitulo>
          <S.HelpTour
            type="button"
            onClick={() => {
              setAberto(false);
              start();
            }}
          >
            {TOUR_TOUR_GUIADO}
          </S.HelpTour>
          <S.HelpMenuTitulo>{TOUR_TROCAR_TOPICO}</S.HelpMenuTitulo>
          {topics.map(t => (
            <S.HelpItem
              key={t.id}
              type="button"
              onClick={() => {
                setAberto(false);
                show(t.id);
              }}
            >
              {t.title}
            </S.HelpItem>
          ))}
        </S.HelpMenu>
      )}
    </S.HelpWrap>
  );
};

export default HelpButton;
